// @flow
/* eslint-disable react/no-array-index-key*/

import React from 'react'
import {bemm} from '../../../shared/bem'
import {template} from './template'
import {SvgHelper} from '../../../shared/mandat-svg/SvgHelper/index'
import {placeMandater} from '../../../shared/mandat-svg/index'

import type {Enkeltmandat} from '../../../../domain/result'

import {blokkSvg} from './index.css'

import {fill} from '../../../../stylesheets/parti.css'

type KonstellasjonProps = {
  mandater: Array<Enkeltmandat>
}

const svgHelper = new SvgHelper({
  rows: 4,
  columns: 43,

  radius: 3.5,
  spacing: 2,
  marginHorizontal: 2,
  marginVertical: 2,

  offsetColumn: 21
})
const height = svgHelper.height

export function KonstellasjonSvg(props: KonstellasjonProps) {
  const table: Array<Array<Enkeltmandat>> = placeMandater(
    template,
    props.mandater
  )
  const paths = svgHelper.traceOutlines(table)
  const width = svgHelper.getClippedWidth(table)

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      version="1.1"
      preserveAspectRatio="xMinYMin meet"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={blokkSvg}
    >
      {paths.map(({path, kortNavn}) => {
        return (
          <path
            d={path}
            strokeWidth="0"
            className={bemm(fill, kortNavn.toLowerCase())}
            key={kortNavn}
          />
        )
      })}
      {table.map((column, cIdx) => {
        return column.map((representant, rIdx) => {
          if (!representant) {
            return null
          }

          const pos = svgHelper.getCircle(cIdx, rIdx)

          return (
            <circle
              r={svgHelper.radius}
              cx={pos.x}
              cy={pos.y}
              key={`${cIdx} ${rIdx}`}
              className={bemm(fill, representant.kortNavn.toLowerCase())}
            />
          )
        })
      })}
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/enblokksvisning/Blokk/svg/index.js